import { useEffect } from "react";
import { Modal, Input, message, Form } from "antd";
import { API } from "aws-amplify";
import { CheckOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import MondayButton from "../MondayButton/MondayButton";
import { IconaMbyll, ModalXIcon } from "../../../assets/icons";
import { useAuth } from "../../../authentication/authHelpers";
import dayjsTZ from "../../../utils/dayjs";
import { QOTD_FIELD_ID } from "../../../constantsFactory/quoteOfTheDay";
import "./EditQuoteOfTheDay.scss";

const { TextArea } = Input;

// Both the header trigger and the header's triple-click shortcut need the same
// gate, so it lives next to the modal rather than being repeated.
export const useCanEditQotd = () => {
  const role = useAuth()?.userRole;
  return role === "Admin" || role === "Super Admin";
};

// Manual override of the daily quote, opened from the header and from
// Konfigurimet. Stamping `editedBy` is what stops the next cron run from
// replacing a quote somebody chose deliberately.
function EditQuoteOfTheDay({ open, quote, onCancel, onSaved }) {
  const auth = useAuth();
  const [form] = Form.useForm();

  const { isDarkMode } = useSelector((state) => state.usersList);

  useEffect(() => {
    if (!open) return;
    form.setFieldsValue({
      quote: quote?.quote || "",
      author: quote?.author || "",
    });
  }, [open, quote, form]);

  const handleFinish = () => {
    form
      .validateFields()
      .then(async (res) => {
        const saved = {
          date: dayjsTZ().format("DD/MM/YYYY"),
          // Empty is a valid choice: it leaves the header without a quote for
          // the rest of the day.
          quote: res?.quote || "",
          // A hand-written quote has no English source behind it, so the
          // second line must not survive from the previous pick.
          quoteEn: "",
          author: res?.author || "",
          editedBy: `${auth?.userAccess?.[0]?.given_name || ""} ${
            auth?.userAccess?.[0]?.family_name || ""
          }`.trim(),
        };
        await API.put("programFields", `/programFields/${QOTD_FIELD_ID}`, {
          body: { fieldOptions: saved },
        });
        onSaved(saved);
        message.success("Citimi i ditës u përditësua");
      })
      .catch(() => message.error("Ndodhi një gabim gjatë ruajtjes"));
  };

  if (!open) return null;

  return (
    <Modal
      title="Ndrysho citimin e ditës"
      open={open}
      destroyOnClose
      className={`edit-qotd-modal ${
        isDarkMode ? "dark darkHeader" : "lightHeader"
      }`}
      centered
      onCancel={onCancel}
      closeIcon={<ModalXIcon />}
      footer={[
        <MondayButton
          key="cancel"
          className="mondayButtonRed"
          onClick={onCancel}
          Icon={<IconaMbyll />}
        >
          Anulo
        </MondayButton>,
        <MondayButton
          key="save"
          className="mondayButtonGreen"
          onClick={handleFinish}
          Icon={<CheckOutlined />}
        >
          Ruaj
        </MondayButton>,
      ]}
    >
      <div className="edit-qotd-wrapper">
        <Form form={form}>
          <Form.Item name="quote" label="Citimi">
            <TextArea rows={3} placeholder="Lëre bosh për të mos shfaqur citim" />
          </Form.Item>
          <Form.Item name="author" label="Autori">
            <Input />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
}

export default EditQuoteOfTheDay;
